import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { INameId } from '@modeso/types__aumico-lib-core-be';

import { OrganizationState } from '../../enums/organization-state.enum';
import { IUpdateOrganizationDialogData } from '../../interfaces/update-organization-dialog-data.interface';

@Component({
    selector: 'aumico-update-organization-modal',
    templateUrl: './update-organization-modal.component.html',
    styleUrls: ['./update-organization-modal.component.scss'],
})
export class UpdateOrganizationModalComponent implements OnInit {
    organizationStatusOptions: INameId[] = [];
    stateFormControl: FormControl;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IUpdateOrganizationDialogData,
        private matDialogRef: MatDialogRef<UpdateOrganizationModalComponent>,
    ) {
        this.setOptions();
    }

    ngOnInit(): void {
        const organizationStateNameId = this.organizationStatusOptions.find(
            (value) => value.name === this.data.organization.state,
        );
        this.stateFormControl = new FormControl(organizationStateNameId, Validators.required);
    }

    private setOptions(): void {
        Object.entries(OrganizationState).forEach(([key, value]) => {
            this.organizationStatusOptions.push({
                id: key,
                name: value,
            });
        });
    }
    onAction() {
        const state = this.stateFormControl.value['name'];
        this.data.action(state);
        this.closeDialog();
    }
    closeDialog(): void {
        this.matDialogRef.close();
    }
}
